var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-lines */
/* eslint-disable react/no-multi-comp */
import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { Translate } from "../../../../../I18N";
import { Button, Pill } from "../../../../Components/UI";


const pxColumnHelper = createColumnHelper();

const TableHeaderContainer = ({ children }) => /*#__PURE__*/
_jsx("span", { className: "text-gray-500 font-semibold text-xs" }, void 0, children);

const TemplateHeader = () => /*#__PURE__*/
_jsx(TableHeaderContainer, {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Template")
);

const EntityHeader = () => /*#__PURE__*/
_jsx(TableHeaderContainer, {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Entity")
);

const DocumentHeader = () => /*#__PURE__*/
_jsx(TableHeaderContainer, {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Document")
);

const LanguageHeader = () => /*#__PURE__*/
_jsx(TableHeaderContainer, {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Language")
);

const ParagraphCountHeader = () => /*#__PURE__*/
_jsx(TableHeaderContainer, {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Paragraphs")
);

const ActionHeader = () => /*#__PURE__*/
_jsx(TableHeaderContainer, {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Action")
);


const DisplayCell = ({
  cell



}) => /*#__PURE__*/_jsx("span", { className: "text-xs font-medium text-gray-900" }, void 0, cell.getValue());

const LanguagesCell = ({ cell }) => /*#__PURE__*/
_jsx("div", { className: "flex flex-wrap gap-2" }, void 0,
cell.getValue().map((value) => /*#__PURE__*/
_jsx("div", { className: "whitespace-nowrap" }, value, /*#__PURE__*/
_jsx(Pill, { color: "gray" }, void 0, value)
)
)
);


const LinkButton = ({ cell }) => /*#__PURE__*/
_jsx(Link, { to: `${cell.getValue()}/paragraphs` }, void 0, /*#__PURE__*/
_jsx(Button, { className: "leading-4", styling: "outline" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "View")
)
);


const TemplateCell = ({ cell }) => /*#__PURE__*/
_jsx("div", { className: "flex flex-wrap gap-2" }, void 0, /*#__PURE__*/
_jsx("div", { className: "whitespace-nowrap" }, void 0, /*#__PURE__*/
_jsx(Pill, { color: "gray" }, void 0, cell.getValue())
)
);


const tableColumns = [
pxColumnHelper.accessor('templateName', {
  header: TemplateHeader,
  enableSorting: true,
  cell: TemplateCell
}),
pxColumnHelper.accessor('title', {
  header: EntityHeader,
  enableSorting: true,
  cell: DisplayCell
}),
pxColumnHelper.accessor('document', {
  header: DocumentHeader,
  enableSorting: true,
  cell: DisplayCell
}),
pxColumnHelper.accessor('languages', {
  header: LanguageHeader,
  enableSorting: true,
  cell: LanguagesCell
}),
pxColumnHelper.accessor('paragraphCount', {
  header: ParagraphCountHeader,
  enableSorting: true,
  cell: DisplayCell
}),
pxColumnHelper.accessor('_id', {
  header: ActionHeader,
  enableSorting: true,
  cell: LinkButton
})];


export { tableColumns };